"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.salutationMap = exports.Salutation = void 0;
var Salutation;
(function (Salutation) {
    Salutation[Salutation["NONE"] = 0] = "NONE";
    Salutation[Salutation["MR"] = 1] = "MR";
    Salutation[Salutation["MRS"] = 2] = "MRS";
    Salutation[Salutation["MISS"] = 3] = "MISS";
    Salutation[Salutation["DR"] = 4] = "DR";
})(Salutation = exports.Salutation || (exports.Salutation = {}));
exports.salutationMap = (_a = {},
    _a[Salutation.NONE] = '',
    _a[Salutation.MR] = 'Mr.',
    _a[Salutation.MRS] = 'Mrs.',
    _a[Salutation.MISS] = 'Miss.',
    _a[Salutation.DR] = 'Dr.',
    _a);
